<template>
  <div class="platform-info-edit-wrp ft-12" v-loading="loading" element-loading-body>
    <el-form class="form" :model="formData" :rules="rules" ref="formRef" label-width="120px">
      <!-- 团购介绍 -->
      <section>
        <div class="title ft-12"><span>团购介绍</span></div>
      </section>
      <div class="conf">
        <el-form-item label="团购名称" prop="groupTitle">
          <el-input v-model="formData.groupTitle" placeholder="请输入团购名称">
            <span slot="suffix" style="margin-right: 6px">{{ getBytesCount(formData.groupTitle) }}/200</span>
          </el-input>
        </el-form-item>
        <el-form-item label="团购时间" prop="groupTime">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          />
          -
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item label="发布方式" prop="groupPublishConfig">
          <el-radio-group v-model="formData.groupPublishConfig">
            <el-radio :label="0">直接开团</el-radio>
            <el-radio :label="1">发布预告团</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <section v-if="!loading">
        <div class="title ft-12"><span>团购商品</span></div>
      </section>
      <div class="conf">
        <div class="ktt-main-wrap">
          <ProductList
            :products="products"
            :errorMap="errorMap"
            :errorImgsMap="errorImgsMap"
            :activeIndex="activeIndex"
            @select="handleSelect"
            @add="handleAdd"
            @delete="handleDelete"
          />
          <div class="form-area">
            <ProductForm
              v-if="products.length && products[activeIndex]"
              ref="productFormRef"
              :activeIndex="activeIndex"
              :skuTableCols="skuTableCols"
              v-model="products[activeIndex]"
            />
          </div>
        </div>
      </div>
    </el-form>
    <SelectProd ref="SelectProdRef" />
  </div>
</template>

<script>
import SelectProd from '@components/common/selectProd/Index.vue';
import ProductList from './components/ProductList.vue';
import ProductForm from './components/ProductForm.vue';

import { getBytesCount } from '@utils/data';
import { mainRules, picUrlLimits, specImgLimits } from './rules';
import { getKttDetail } from '@/servers/prod/center/ktt.js';
import { getImgFileSize } from '@/api/base/index.js';

import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import { _getImageSize } from '@/store/modules/image';

// const allSuffix = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];

export default {
  name: 'InfoForm',
  components: { ProductList, ProductForm, SelectProd },
  props: {
    initBaseItemIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isDistributor: Boolean,
  },
  data() {
    return {
      getBytesCount,
      rules: mainRules(this),
      products: [],
      loading: false,
      formData: {
        groupTitle: '',
        startTime: '',
        endTime: '',
        groupPublishConfig: 1,
      },
      activeIndex: 0,
      errorMap: {},
      errorImgsMap: {},
      skuTableCols: [
        {
          prop: 'price',
          attrs: { label: '价格' },
          input: {
            type: 'number',
          },
        },
        {
          prop: 'quantity',
          attrs: { label: '库存' },
          input: {
            type: 'number',
            attrs: { precision: 0 },
          },
        },
        { prop: 'skuOuterId', attrs: { label: '商家编码', width: 200 }, input: { type: 'text', onlyTable: true }, headerSlot: true },
        { prop: 'retailPrice', attrs: { label: '零售价' } },
        // { prop: 'status', attrs: { label: '商品状态' } },
      ],
    };
  },
  computed: {
    ...mapGetters(['imageCacheSizes']),
    allBaseItemIds() {
      return this.products.map(item => item.baseItemId);
    },
  },
  methods: {
    ...mapActions(['cacheImageFileSize']),
    async initData() {
      this.loading = true
      this.products = await this.getDetailData(this.initBaseItemIds);
      this.validate();
      await this.validateImgs(this.products);
      delete this.errorImgsMap[this.products[this.activeIndex].baseItemId];
      this.loading = false
    },
    async getDetailData(baseItemIds) {
      if (!baseItemIds?.length) return;
      const data = await getKttDetail({
        baseItemIds: baseItemIds.join(','),
      });
      return data;
    },
    async handleSelect(idx, baseItemId) {
      this.activeIndex = idx;
      delete this.errorImgsMap[baseItemId];
      await this.validate();
    },
    handleAdd() {
      this.$refs.SelectProdRef.method_open({
        okFn: async selectList => {
          let baseItemIds = selectList
            .map(row => {
              if (this.isDistributor) {
                return row.distributionBaseItemIds?.length ? row.distributionBaseItemIds[0] : row.baseItemId;
              } else {
                return row.itemId ? row.itemId : row.baseItemId;
              }
            })
            .filter(id => !this.allBaseItemIds.includes(id));
          if (!baseItemIds.length) return;
          this.loading = true
          const newProducts = await this.getDetailData(baseItemIds);
          if (!newProducts || !newProducts.length) return;
          const startIndex = this.products.length;
          this.products.push(...newProducts);
          this.activeIndex = startIndex; // 指向新加的第一个商品
          await this.validate();
          await this.validateImgs(newProducts);
          delete this.errorImgsMap[this.products[this.activeIndex].baseItemId];
          this.loading = false
        },
      });
    },
    async handleDelete(baseItemId) {
      const index = this.products.findIndex(item => item.baseItemId === baseItemId);
      if (index === -1) return; // 未找到直接返回
      this.products.splice(index, 1);

      if (this.products.length === 0) {
        this.activeIndex = 0;
      } else if (this.activeIndex >= this.products.length) {
        // 删除的是最后一个，activeIndex 指向最后一个
        this.activeIndex = this.products.length - 1;
      } else if (this.activeIndex > index) {
        // 删除的是前面的项，activeIndex 需左移
        this.activeIndex -= 1;
      }
      delete this.errorImgsMap[baseItemId];
      await this.validate();
    },
    async method_getFormData() {
      // 统一使用 async/await，避免回调与异步混用导致的误判
      const formValid = await new Promise(resolve => {
        if (!this.$refs.formRef || !this.$refs.formRef.validate) return resolve(false);
        this.$refs.formRef.validate(valid => resolve(valid));
      });

      const [curFormValid, validateResult] = await Promise.all([
        this.$refs.productFormRef && this.$refs.productFormRef.validate ? this.$refs.productFormRef.validate() : Promise.resolve(false),
        this.validate(),
      ]);
      if (!formValid || !curFormValid || !validateResult) {
        this.$message.error('请完善发布内容！');
        return false;
      }
      const data = {
        groupData: this.formData,
        products: this.products,
      };
      return cloneDeep(data);
    },
    async validateImgs(list) {
      if (!Array.isArray(list) || !list.length) return true;

      // 批量校验所有产品的图片
      const results = await Promise.all(
        list.map(async (form, idx) => {
          if (idx === this.activeIndex) return true;
          try {
            // 收集所有需要校验的图片
            const allImagePromises = [];

            // 添加产品主图校验
            if (form.picUrl?.length) {
              allImagePromises.push(
                ...form.picUrl.map(url =>
                  this.validImg(url, picUrlLimits)
                    .then(() => null)
                    .catch(error => ({ url, error }))
                )
              );
            }

            // 添加规格图片校验
            for (const specification of form.specifications || []) {
              for (const value of specification.values || []) {
                if (!value.checked || !value.imageUrl) continue;
                allImagePromises.push(
                  this.validImg(value.imageUrl, specImgLimits)
                    .then(() => null)
                    .catch(error => ({ url: value.imageUrl, error }))
                );
              }
            }

            // 并行校验所有图片
            const imgResults = await Promise.all(allImagePromises);
            
            // 过滤出校验失败的图片
            const errors = imgResults.filter(Boolean);
            if (errors.length) {
              // 记录错误信息
              errors.forEach(({ url, error }) => {
                console.error(`图片校验失败 ${url}: ${error}`);
              });

              // 更新错误状态
              this.$set(this.errorImgsMap, form.baseItemId, true);
              return true;
            }

            // 清除错误状态
            this.$delete(this.errorImgsMap, form.baseItemId);
            return false;
          } catch (error) {
            console.error('图片校验异常:', error);
            this.$set(this.errorImgsMap, form.baseItemId, true);
          }
        })
      );

      // 只要有一个产品的图片校验失败，整体校验就失败
      return !results.some(Boolean);
    },
    async validate() {
      // 校验所有产品并返回校验结果
      const validationResults = await Promise.all(
        this.products.map(async form => {
          // 检查必填字段和规格/SKU的校验结果
          const specError = await this.validateSpecifications(form.specifications || []);
          const skuError = await this.validateSkuList(form.skuList || []);

          const hasError = !form.goodsName || !form.goodsDesc || specError || skuError;

          // 更新错误状态映射
          this.$set(this.errorMap, form.baseItemId, hasError);

          return hasError;
        })
      );

      // 如果任一产品校验失败则返回false
      return !validationResults.some(Boolean);
    },
    validImg(url, rule) {
      const { limitSuffix, limitSize, limitWidth, limitHeight, aspectRatio } = rule;
      return new Promise((resolve, reject) => {
        if (!url) {
          reject('图片URL不能为空');
          return;
        }

        // 检查图片格式 - 使用更精确的正则表达式
        if (limitSuffix) {
          const formatList = limitSuffix.split(',').map(format => format.replace('.', '').toLowerCase());

          // 提取URL中的文件扩展名
          const urlMatch = url.toLowerCase().match(/\.([a-z0-9]+)(?:[?#]|$)/i);
          const urlExtension = urlMatch ? urlMatch[1] : null;

          // 检查format参数（适用于某些CDN）
          const formatMatch = url.toLowerCase().match(/[?&]format=([a-z0-9]+)/i);
          const formatParam = formatMatch ? formatMatch[1] : null;

          const hasValidFormat = formatList.includes(urlExtension) || formatList.includes(formatParam);

          if (!hasValidFormat && (urlExtension || formatParam)) {
            reject(`图片格式不支持，仅支持${formatList.join('/')}格式，当前格式：${urlExtension || formatParam}`);
            return;
          }
        }

        // 创建图片对象进行尺寸和大小检查
        const img = new Image();
        img.crossOrigin = 'anonymous';

        // 添加超时处理
        const timeout = setTimeout(() => {
          resolve(true);
          // reject('图片加载超时，请检查网络连接或图片URL');
        }, 10000); // 10秒超时

        img.onload = async () => {
          clearTimeout(timeout);
          try {
            // 检查宽高比（1:1）
            if (aspectRatio && aspectRatio.includes(1)) {
              const ratio = img.width / img.height;
              if (Math.abs(ratio - 1) > 0.01) {
                // 允许1%的误差
                reject(`图片宽高比不符合要求，需要1:1比例，当前比例：${ratio.toFixed(2)}:1`);
                return;
              }
            }

            // 检查宽度限制
            if (limitWidth && limitWidth.length === 2) {
              const [minWidth, maxWidth] = limitWidth;
              if (minWidth && img.width < minWidth) {
                reject(`图片宽度不能小于${minWidth}像素，当前宽度：${img.width}像素`);
                return;
              }
              if (maxWidth && img.width > maxWidth) {
                reject(`图片宽度不能大于${maxWidth}像素，当前宽度：${img.width}像素`);
                return;
              }
            }

            // 检查高度限制
            if (limitHeight && limitHeight.length === 2) {
              const [minHeight, maxHeight] = limitHeight;
              if (minHeight && img.height < minHeight) {
                reject(`图片高度不能小于${minHeight}像素，当前高度：${img.height}像素`);
                return;
              }
              if (maxHeight && img.height > maxHeight) {
                reject(`图片高度不能大于${maxHeight}像素，当前高度：${img.height}像素`);
                return;
              }
            }

            // 检查文件大小
            if (limitSize) {
              let resSize;
              if (this.imageCacheSizes[url]) {
                // resSize = this.imageCacheSizes[url];
                resSize = await new Promise(r => _getImageSize(r, reject, () => this.imageCacheSizes[url], '获取图片大小失败，请重新上传'));
              } else {
                try {
                  this.cacheImageFileSize({ url, size: -1 });
                  // 校验大小
                  let reqImageSize = this.$worker ? this.$worker : getImgFileSize;
                  let res = await reqImageSize(url, { isNeedLoading: false });
                  if (res === 'WorkerError') {
                    res = await getImgFileSize(url, { isNeedLoading: false });
                  }
                  if (!res || !res.data) {
                    this.cacheImageFileSize({ url, size: 0 });
                    reject('获取图片大小失败，请重新上传');
                    return;
                  }
                  resSize = res.data;
                  this.cacheImageFileSize({ url, size: resSize });
                } catch (sizeError) {
                  this.cacheImageFileSize({ url, size: 0 });
                  reject('获取图片大小时发生错误：' + sizeError.message);
                  return;
                }
              }
              if (resSize > limitSize) {
                const size_M = (limitSize / 1024 / 1024).toFixed(2);
                const current_M = (resSize / 1024 / 1024).toFixed(2);
                reject(`图片大小不能超过${size_M}M，当前大小：${current_M}M`);
                return;
              }
            }

            // 所有校验通过
            resolve(true);
          } catch (error) {
            reject('图片校验过程中发生错误：' + error.message);
          }
        };

        img.onerror = () => {
          clearTimeout(timeout);
          reject('图片加载失败，请检查图片URL是否有效');
        };

        img.src = url;
      });
    },
    validateSpecifications(specifications = []) {
      if (!Array.isArray(specifications) || specifications.length === 0) return false;
      const specNames = new Set();
      for (const specification of specifications) {
        if (!specification.name) {
          return '请补充规格名';
        }
        if (specNames.has(specification.name)) {
          return `规格名【${specification.name}】重复`;
        }
        specNames.add(specification.name);

        const valueSet = new Set();
        for (const value of specification.values || []) {
          if (!value.checked) continue;
          if (!value.value) {
            return `${specification.name}规格下的规格值未完善`;
          }
          if (valueSet.has(value.value)) {
            return `${value.value}规格值重复`;
          }
          valueSet.add(value.value);
        }
      }
      return false;
    },
    validateSkuList(skuList = []) {
      if (!Array.isArray(skuList) || skuList.length === 0) return false;
      const props = this.skuTableCols
        .filter(item => item.input)
        .map(item => ({
          ...item,
          label: item.attrs.label,
          validator: this.getValidatorFn(item),
        }));
      for (const sku of skuList) {
        for (const prop of props) {
          if (prop.validator) {
            const errmsg = prop.validator(sku[prop.prop], prop, sku);
            if (errmsg) {
              return errmsg;
            }
          }
        }
      }
      return false;
    },
    getValidatorFn(item) {
      const { input, attrs, visibleFn, unvisible } = item;
      if (attrs?.noRequired || unvisible || (visibleFn && !visibleFn())) {
        return null;
      }
      return input.validator || this.validateVoid;
    },
    // 校验空值
    validateVoid(value, prop, sku) {
      if (value === '' || value === undefined || value === null) {
        if (prop.disabledFn && prop.disabledFn(sku)) {
          return false;
        }

        return `商品明细中${prop.label}请勿输入空值`;
      }
      return false;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.platform-info-edit-wrp {
  .ktt-main-wrap {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: flex-start;
  }
  .form-area {
    flex: 1;
    min-width: 0;
  }
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>